<ng-container *transloco="let t">
  <div
    class="position-fix-container"
    [ngStyle]="{ 'background-color': backgroundColor }"
    [ngClass]="isNewspaperShowing ? 'widget-container--width-' + widget.cols : ''"
    [class.position-fix-container--expansion-panel]="isExpansionPanelShowing"
    #widgetContainer
  >
    @if (selectModeStore.filtersSourceWidgetId() === widget.id) {
      <div class="source-widget">
        <div class="layer">
          <h1 class="source-mark-title">
            <span>
              <img class="inline-filter-icon" src="assets/icons/filter-blue-24-px.svg" />
              {{ t('widgets.filter-source') }}
            </span>
          </h1>
        </div>
      </div>
    }
    @if (selectModeStore.mode() === 'edit') {
      <div class="select-handle">
        <div
          class="layer"
          [class.layer-disabled]="
            widget.payload.isSpecial || (isPredictive && widget.payload.type !== 'predictor')
          "
        >
          @if (
            !widget.payload.isSpecial && (!isPredictive || widget.payload.type === 'predictor')
          ) {
            <div class="move-circle drag-handler">
              <mat-icon>open_with</mat-icon>
            </div>
          }
        </div>
      </div>
    }
    @if (selectModeStore.mode() && selectModeStore.mode() !== 'edit') {
      <div class="select-handle" (click)="toggleSelectedWidget()">
        <div
          class="layer"
          [class.unchecked]="!isSelected"
          [class.layer-disabled]="!isWidgetSelectable()"
        >
          @if (isWidgetSelectable()) {
            <div class="check-circle">
              <mat-icon [class.checked]="isSelected">check</mat-icon>
            </div>
            @if (selectModeStore.isActivityBarSelectAction()) {
              <div class="widget-selection-text">
                {{ widgetSelectionText() }}
              </div>
            }
          } @else {
            <div class="widget-selection-text">
              {{ widgetSelectionText() }}
            </div>
          }
        </div>
      </div>
    }

    <div class="widget-header">
      @if (!widget.payload.hideTitle) {
        <div
          class="truncate-text title-wrapper"
          [class.blur-effect]="selectModeStore.filtersSourceWidgetId() === widget.id"
        >
          @if (shouldShowTitleAsterisk) {
            <span>*</span>
          }
          <xi-editable-text
            type="text"
            [maxLength]="40"
            [stretch]="true"
            [readonly]="isReadOnly || isCustomSortMode"
            [disabled]="isReadOnly || dashboard?.locked || isExpansionPanelShowing"
            [value]="widget.title ? widget.title : isLocked ? '' : defaultTitle"
            (onInputEnter)="onTitleChanged($event.detail.text)"
            (onBlur)="onTitleChanged($event.detail.target.value)"
          ></xi-editable-text>
        </div>
      }
      @if (widgetInfo) {
        <div
          [matTooltip]="widgetInfo.tooltip"
          [ngClass]="'info-icon--' + widgetInfo.level"
          class="info-icon"
        >
          <mat-icon>{{ widgetInfo.icon }}</mat-icon>
        </div>
      }
      @if (!isNote && !widget.payload.hideTitle) {
        <div
          class="about-widget-icon"
          [ngbPopover]="aboutWidgetPopoverContent"
          triggers="mouseenter:mouseleave"
          placement="bottom-right bottom-left bottom"
          [container]="'body'"
          popoverClass="about-widget-popover"
        >
          <mat-icon fontSet="kitchen-icons" color="primary" fontIcon="kxi-icon-info"></mat-icon>
        </div>
      }
    </div>

    @if (!isNote) {
      @if (!isCustomSortMode) {
        <div
          #actionBarContainer
          class="widget__sub-header-container"
          [class.widget__sub-header-container--redrawing]="isDrawingActionItems"
        >
          <div class="widget__sub-header-column">
            @if (isWidgetDirty()) {
              <div>
                <button
                  matSuffix
                  mat-icon-button
                  [matTooltip]="t('widgets.data-source-modified')"
                  (click)="refreshWidget()"
                  class="xi-icon-button-normal"
                >
                  <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-refresh"></mat-icon>
                </button>
              </div>
            }
            @if (isPredictive && widget.payload.type !== 'predictor') {
              <app-predictive-widget-datepickers
                [dashboard]="dashboard"
                [widgetDataSource]="widgetDataSource"
                [widget]="widget"
                (predictiveDateRangeChanged)="predictiveDateRangeChanged($event)"
              ></app-predictive-widget-datepickers>
            }

            @if (isInsightFeed()) {
              <div
                class="widget__sub-header-item widget__insight-feed-source kxi-padding-left-small kxi-padding-right-small"
              >
                <xi-dropdown
                  select="single"
                  placeholder="Select a Feed"
                  [data]="insightFeedSourceOptions"
                  [value]="selectedInsightFeedValue"
                  [disabled]="dashboard?.locked || isExpansionPanelShowing"
                  (onValueChange)="onInsightFeedSourceChange($event.detail.selected.id)"
                ></xi-dropdown>
              </div>
            } @else {
              <app-dashboard-pill-wrapper
                class="widget__sub-header-item kxi-margin-vertical-small"
                [disabled]="dashboard?.locked || isExpansionPanelShowing"
                [isReadOnly]="isReadOnly"
                [dashboardId]="dashboardId"
                [currentPageId]="widget.payload.page"
                [currentWidgets]="[this.widget]"
                [activityParent]="widgetContainer"
                [containerParent]="actionBarContainer"
                [dashboard]="dashboard"
                [widget]="widget"
                [report]="currentReport"
                [detailsHidden]="detailsHidden"
                [widgetComponent]="widgetComponent"
                [beforeCompact]="onBeforePillCompact"
                [afterCompact]="onAfterPillCompact"
                (onActivitybarInteraction)="onActivitybarInteraction.emit($event)"
              ></app-dashboard-pill-wrapper>
            }

            @if (
              !hasInvalidComparison &&
              widget.payload.type === 'crosstab' &&
              widget.payload.graphType !== 'dependencywheel'
            ) {
              <div class="widget__crosstab-sort-container">
                <span
                  (click)="clearCrosstabCustomSort()"
                  [class.widget__crosstab-sort-clear--disabled]="isExpansionPanelShowing"
                  >{{ t('widgets.clear-sort') }}</span
                >

                <button
                  matSuffix
                  mat-icon-button
                  [disabled]="isExpansionPanelShowing"
                  [matTooltip]="
                    isExpansionPanelShowing
                      ? t('widgets.can-not-sort-expansion-panel')
                      : t('widgets.custom-sort')
                  "
                  (click)="enableCrosstabCustomSort()"
                  class="xi-icon-button-normal"
                >
                  <mat-icon
                    fontSet="kitchen-icons"
                    [fontIcon]="
                      widget.payload.sort?.field === 'custom' ||
                      widget.payload.columnSort?.field === 'custom'
                        ? 'kxi-icon-edit_filled'
                        : 'kxi-icon-edit'
                    "
                  ></mat-icon>
                </button>
              </div>
            }
          </div>

          @if (widget.payload.zoomDateFilter && !dashboard.locked) {
            <div class="widget__sub-header-column">
              <button
                matSuffix
                mat-icon-button
                [matTooltip]="t('widgets.add-to-widget-group')"
                (click)="addFilterToWidgetGroup()"
                class="xi-icon-button-normal"
              >
                <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-filter_add_filled"></mat-icon>
              </button>

              <button
                matSuffix
                mat-icon-button
                [matTooltip]="t('widgets.reset-zoom')"
                (click)="resetZoom()"
                class="xi-icon-button-normal"
              >
                <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-remove_circle"></mat-icon>
              </button>
            </div>
          }
          @if (widgetActions.insightFeedsWidgetActions?.header === true) {
            <div class="widget__sub-header-column widget__sub-header-column--actions text-blue">
              <button
                matSuffix
                mat-icon-button
                [matTooltip]="
                  insightFeedSortIcon === 'kxi-icon-sort_order_asc'
                    ? t('widgets.sort-newest')
                    : t('widgets.sort-oldest')
                "
                (click)="toggleInsightFeedSortOrder()"
                class="xi-icon-button-normal"
              >
                <mat-icon fontSet="kitchen-icons" [fontIcon]="insightFeedSortIcon"></mat-icon>
              </button>

              <button
                matSuffix
                mat-icon-button
                [disabled]="isWidgetDisabled || !selectedInsightFeedItems.length"
                [matTooltip]="t('widgets.download')"
                (mousedown)="$event.stopPropagation()"
                (click)="downloadSelectedInsightsAsPptx()"
                class="xi-icon-button-normal"
              >
                <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-download"></mat-icon>
              </button>

              <button
                matSuffix
                mat-icon-button
                [disabled]="isWidgetReadOnly"
                [matTooltip]="t('widgets.create-insight-feed-dialog.create-new-feed')"
                (click)="onOpenCreateInsightFeedModal('create')"
                class="xi-icon-button-normal"
              >
                <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-add_circle"></mat-icon>
              </button>

              <button
                matSuffix
                mat-icon-button
                [disabled]="isWidgetReadOnly || !selectedInsightFeedValue"
                [matTooltip]="t('widgets.create-insight-feed-dialog.edit-feed')"
                (click)="onOpenCreateInsightFeedModal('edit')"
                class="xi-icon-button-normal"
              >
                <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-edit"></mat-icon>
              </button>
            </div>
          }
          @if (!dashboard.locked) {
            <div
              #actionswrapper
              class="widget__sub-header-column widget__sub-header-column--actions text-blue"
            >
              @if (widgetActions.comments?.header === true) {
                @if (isWidgetDisabled || widgetActions.comments.disabled) {
                  <ng-container
                    *ngTemplateOutlet="commentIconContainer; context: { $implicit: true }"
                  ></ng-container>
                } @else {
                  <div [matMenuTriggerFor]="commentsMenu">
                    <ng-container *ngTemplateOutlet="commentIconContainer"></ng-container>
                  </div>
                }

                <ng-template #commentIconContainer let-isDisabled>
                  <div
                    [matBadge]="widget.payload.comments?.length ? '1' : ''"
                    matBadgeSize="small"
                    [matTooltip]="widgetActions.comments.tooltip"
                    class="small-badge"
                  >
                    <button
                      matSuffix
                      mat-icon-button
                      [disabled]="isDisabled"
                      class="xi-icon-button-normal"
                    >
                      <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-comment"></mat-icon>
                    </button>
                  </div>
                </ng-template>
              }
              @if (widgetActions.displayDocumentTableView?.header === true) {
                <div class="document-list-icon">
                  <div>
                    <button
                      matSuffix
                      mat-icon-button
                      [matTooltip]="t('widgets.documents-is-card-view')"
                      [disabled]="isWidgetDisabled"
                      (click)="documentListDisplayView('edit')"
                      class="xi-icon-button-normal"
                    >
                      <mat-icon
                        fontSet="kitchen-icons"
                        [fontIcon]="
                          widget.payload.isCardView
                            ? 'kxi-icon-view_normal_filled'
                            : 'kxi-icon-view_normal'
                        "
                      ></mat-icon>
                    </button>
                  </div>

                  <div>
                    <button
                      matSuffix
                      mat-icon-button
                      [matTooltip]="t('widgets.documents-is-table-view')"
                      [disabled]="isWidgetDisabled"
                      (click)="documentListDisplayView(false)"
                      class="xi-icon-button-normal"
                    >
                      <mat-icon
                        fontSet="kitchen-icons"
                        [fontIcon]="
                          widget.payload.isCardView
                            ? 'kxi-icon-view_table'
                            : 'kxi-icon-view_table_filled'
                        "
                      ></mat-icon>
                    </button>
                  </div>
                </div>
              }
              @if (widgetActions.displaySettings?.header === true) {
                <div>
                  <button
                    matSuffix
                    mat-icon-button
                    [matTooltip]="t('widgets.documents-widget-options')"
                    [disabled]="isWidgetDisabled"
                    (click)="openDocumentListSettings()"
                    class="xi-icon-button-normal"
                  >
                    <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-settings"></mat-icon>
                  </button>
                </div>
              }
              @if (widgetActions.weight?.header === true) {
                @if (isWidgetDisabled || widgetActions.weight.disabled) {
                  <ng-container
                    *ngTemplateOutlet="weightIconContainer; context: { $implicit: true }"
                  ></ng-container>
                } @else {
                  <div [matMenuTriggerFor]="weightMenu">
                    <ng-container *ngTemplateOutlet="weightIconContainer"></ng-container>
                  </div>
                }

                <ng-template #weightIconContainer let-isDisabled>
                  <div
                    [matTooltip]="widgetActions.weight.tooltip"
                    [matBadge]="widget.payload.weightField ? '1' : ''"
                    matBadgeSize="small"
                    [matMenuTriggerFor]="weightMenu"
                    class="small-badge"
                  >
                    <button
                      matSuffix
                      mat-icon-button
                      [disabled]="isDisabled"
                      class="xi-icon-button-normal"
                    >
                      <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-scale"></mat-icon>
                    </button>
                  </div>
                </ng-template>
              }
              @if (widgetActions.filter?.header === true) {
                <div
                  [matBadge]="getComponent()?.hasFilters ? '1' : ''"
                  matBadgeSize="small"
                  class="small-badge"
                  matTooltipClass="filter-document-tooltip"
                >
                  <button
                    matSuffix
                    mat-icon-button
                    [matTooltip]="
                      t('widgets.filtered-document-count', {
                        filteredCount:
                          elementComponent.filteredDocumentCount === undefined
                            ? '…'
                            : (currentFilteredDocumentCount | humanizeInt: 1 : 100000),
                        totalCount: (currentDocumentCount | humanizeInt: 1 : 100000),
                        percentage: filteredDocumentPercentage,
                      })
                    "
                    [disabled]="
                      isWidgetDisabled || !!isCustomSortMode || widgetActions.filter?.disabled
                    "
                    (click)="filterWidget()"
                    class="xi-icon-button-normal"
                  >
                    <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-filter"></mat-icon>
                  </button>
                </div>
              }
              @if (widgetActions.hiddenItems?.header === true) {
                <div
                  #hiddenItemsPopover="ngbPopover"
                  [ngbPopover]="hiddenItemsPopContent"
                  triggers="manual"
                  placement="bottom"
                  [popoverTitle]="t('widgets.hidden-items')"
                  popoverClass="widget-menu-hidden-items-popover"
                  [autoClose]="'outside'"
                  [container]="'body'"
                  [matTooltip]="
                    t('widgets.count-hidden-items', {
                      count: widget.payload.excludedValues?.length || 0,
                    })
                  "
                  (shown)="preventPropagation(hiddenItemsPopover)"
                >
                  <button
                    matSuffix
                    mat-icon-button
                    [disabled]="disabledWidgetHiddenItems || !!isCustomSortMode"
                    (click)="openHiddenItemsPopover(hiddenItemsPopover)"
                    class="xi-icon-button-normal"
                  >
                    <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-visibility"></mat-icon>
                  </button>
                </div>
              }
              @if (widgetActions.sentimentFilter?.header === true) {
                <div [matTooltip]="widgetActions.sentimentFilter?.tooltip">
                  <button
                    mat-icon-button
                    (click)="openWidgetSentimentFilter()"
                    [disabled]="
                      isWidgetDisabled ||
                      widgetActions.sentimentFilter?.disabled ||
                      isCustomSortMode
                    "
                    [matBadge]="widgetActions.sentimentFilter?.badge"
                    matBadgeSize="small"
                    class="small-badge xi-icon-button-normal"
                  >
                    <mat-icon svgIcon="xi_sentiment_positive"></mat-icon>
                  </button>
                </div>
              }
              @if (widgetActions.chartOptions?.header === true) {
                <div>
                  <button
                    matSuffix
                    mat-icon-button
                    [matTooltip]="t('widgets.chart-options')"
                    [disabled]="isWidgetDisabled || !!isCustomSortMode"
                    (click)="onOpenWidgetChartOptionsModal()"
                    class="xi-icon-button-normal"
                  >
                    <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-chart"></mat-icon>
                  </button>
                </div>
              }

              @if (widgetActions.analyticItem?.header === true && canChangeAnalyticItem()) {
                <div>
                  <button
                    matSuffix
                    mat-icon-button
                    [matTooltip]="widgetAnalyticTypeTooltip()"
                    [disabled]="
                      isWidgetDisabled || !!isCustomSortMode || analyticItemChangeDisabled()
                    "
                    (click)="openAnalyticTypeDialog()"
                    class="xi-icon-button-normal"
                  >
                    <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-reporting"></mat-icon>
                  </button>
                </div>
              }

              @if (widgetActions.contentLimit?.header === true) {
                <div>
                  <button
                    mat-icon-button
                    #contentLimitPopover="ngbPopover"
                    [disabled]="disabledContentLimit() || !!isCustomSortMode"
                    (click)="openContentLimitPopover(contentLimitPopover)"
                    [ngbPopover]="contentLimitTemplate"
                    popoverClass="content-limit-popover"
                    placement="bottom-right"
                    triggers="manual"
                    [container]="'body'"
                    [autoClose]="'outside'"
                    [matTooltip]="t('widgets.content-limit')"
                    (shown)="preventPropagation(contentLimitPopover)"
                    class="xi-icon-button-normal content-limit-button"
                  >
                    <div
                      class="content-limit-button__label"
                      [class.content-limit-button__label--disabled]="disabledContentLimit()"
                    >
                      {{ contentLimitLabel() }}
                    </div>
                  </button>
                </div>
              }

              @if (widgetActions.aiInsights?.header === true) {
                <div
                  [matTooltip]="
                    isShowAsDataTable
                      ? t('widgets.ai-insights.disabled-data-table')
                      : widgetActions.aiInsights.tooltip
                  "
                >
                  <button
                    matSuffix
                    mat-icon-button
                    [disabled]="
                      isWidgetDisabled ||
                      isShowAsDataTable ||
                      !!isCustomSortMode ||
                      widgetActions.aiInsights.disabled
                    "
                    (click)="onAiInsightsOpenClicked()"
                    class="xi-icon-button-normal"
                  >
                    <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-lightbulb"></mat-icon>
                  </button>
                </div>
              }

              @if (showWidgetMenu) {
                <ng-container *ngTemplateOutlet="tWidgetMenu"></ng-container>
              }
            </div>
          }
        </div>
      }
    }

    <ng-template #tWidgetMenu>
      <div
        class="widget__widget-menu-trigger"
        [class.widget__widget-menu-trigger--hidden]="
          !widgetMenu.menuOpen && widgetMenuDisplayOnHover
        "
      >
        @if (!isNote) {
          <button
            matSuffix
            mat-icon-button
            [disabled]="!!isCustomSortMode || isExpansionPanelShowing"
            (click)="openWidgetMenu($event)"
            class="xi-icon-button-normal"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-kabob"></mat-icon>
          </button>
        } @else {
          <button class="widget__notes-widget-menu-button" (click)="openWidgetMenu($event)">
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-kabob"></mat-icon>
          </button>
        }
      </div>

      <div #widgetMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="widgetMenu"></div>
    </ng-template>

    @if (!widget.payload.hideTitle) {
      <div class="widget__sub-header-keyline"></div>
    }

    <div
      class="widget-content"
      [class.blur-effect]="selectModeStore.filtersSourceWidgetId() === widget.id"
    >
      @if (isNote && editNote === 'view') {
        <div class="widget__notes-widget-menu-container">
          <ng-content *ngTemplateOutlet="tWidgetMenu"></ng-content>
        </div>
      }

      @switch (widget.component) {
        @case ('DashboardWidgetGridComponent') {
          <app-widget-grid
            #widgetComponent
            [dashboard]="dashboard"
            [widget]="widget"
            [widgetDataSource]="widgetDataSource"
            [widgetGroup]="widgetGroup"
            [comparison]="comparison"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="widgetLoading.emit($event)"
            (loadingFinished)="widgetLoaded.emit($event)"
            [interactiveSmartSummaryEnabled]="interactiveSmartSummaryEnabled"
          />
        }
        @case ('DashboardWidgetInsightFeedComponent') {
          <app-widget-insight-feed
            #widgetComponent
            [project]="project"
            [dashboard]="dashboard"
            [widget]="widget"
            [widgetDataSource]="widgetDataSource"
            [widgetGroup]="widgetGroup"
            [comparison]="comparison"
            [selectedInsightFeed]="selectedInsightFeed"
            [sortInsightToggle]="insightFeedsortInsightToggle"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="widgetLoading.emit($event)"
            (loadingFinished)="widgetLoaded.emit($event)"
            (feedEvent)="onFeedEvent($event)"
            [interactiveSmartSummaryEnabled]="interactiveSmartSummaryEnabled"
          />
        }
        @case ('DashboardWidgetJourneyComponent') {
          <app-widget-journey
            #widgetComponent
            [project]="project"
            [dashboard]="dashboard"
            [widget]="widget"
            [widgetDataSource]="widgetDataSource"
            [widgetGroup]="widgetGroup"
            [comparison]="comparison"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="widgetLoading.emit($event)"
            (loadingFinished)="widgetLoaded.emit($event)"
            [interactiveSmartSummaryEnabled]="interactiveSmartSummaryEnabled"
          />
        }
        @case ('DashboardWidgetImpactComponent') {
          <app-widget-impact
            #widgetComponent
            [dashboard]="dashboard"
            [widget]="widget"
            [widgetGroup]="widgetGroup"
            [comparison]="comparison"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="widgetLoading.emit($event)"
            (loadingFinished)="onLoadingFinished($event)"
            [widgetDataSource]="widgetDataSource"
            [interactiveSmartSummaryEnabled]="interactiveSmartSummaryEnabled"
            (aiInsightPointSelection)="onAiInsightPointSelection($event)"
          />
        }

        @case ('DashboardWidgetPredictiveComponent') {
          <app-widget-predictive
            #widgetComponent
            [dateRange]="predictiveDateRange"
            [dashboard]="dashboard"
            [widget]="widget"
            [widgetGroup]="widgetGroup"
            [comparison]="comparison"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="widgetLoading.emit($event)"
            (loadingFinished)="widgetLoaded.emit($event)"
            [widgetDataSource]="widgetDataSource"
            [interactiveSmartSummaryEnabled]="interactiveSmartSummaryEnabled"
          />
        }

        @case ('DashboardWidgetMarkdownComponent') {
          <app-widget-markdown
            #widgetComponent
            [dashboard]="dashboard"
            [widget]="widget"
            [comparison]="comparison"
            [(mode)]="editNote"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="widgetLoading.emit($event)"
            (loadingFinished)="widgetLoaded.emit($event)"
          />
        }

        @case ('DashboardWidgetNotesComponent') {
          <app-widget-notes
            #widgetComponent
            [dashboard]="dashboard"
            [widgetHeight]="gridsterItem?.height"
            [widget]="widget"
            [comparison]="comparison"
            [(mode)]="editNote"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="widgetLoading.emit($event)"
            (loadingFinished)="widgetLoaded.emit($event)"
          />
        }
        @case ('DashboardWidgetTopMoversComponent') {
          <app-widget-top-movers
            #widgetComponent
            [dashboard]="dashboard"
            [widget]="widget"
            [widgetDataSource]="widgetDataSource"
            [widgetGroup]="widgetGroup"
            [comparison]="comparison"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="widgetLoading.emit($event)"
            (loadingFinished)="widgetLoaded.emit($event)"
            class="widget-top-movers"
          />
        }

        @case ('DashboardWidgetBigNumberComponent') {
          <app-widget-big-number
            #widgetComponent
            [dashboard]="dashboard"
            [widget]="widget"
            [widgetDataSource]="widgetDataSource"
            [widgetGroup]="widgetGroup"
            [comparison]="comparison"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="widgetLoading.emit($event)"
            (loadingFinished)="onLoadingFinished($event)"
            (aiInsightPointSelection)="onAiInsightPointSelection($event)"
          />
        }

        @case ('DashboardWidgetDocumentListComponent') {
          <ng-template *ngTemplateOutlet="chartDoclist"></ng-template>
        }

        @case ('WidgetTaxonomyMapComponent') {
          <app-widget-taxonomy-map
            #widgetComponent
            [dashboard]="dashboard"
            [widget]="widget"
            [project]="project"
            [widgetDataSource]="widgetDataSource"
            [widgetGroup]="widgetGroup"
            [comparison]="comparison"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="widgetLoading.emit($event)"
            (loadingFinished)="widgetLoaded.emit($event)"
            [interactiveSmartSummaryEnabled]="interactiveSmartSummaryEnabled"
            class="widget-taxonomy-map"
          />
        }

        @case ('DashboardWidgetChartComponent') {
          @if (isShowAsDocumentList) {
            <ng-container *ngTemplateOutlet="chartDoclist" />
          } @else {
            @switch (widget.payload.type) {
              @case ('scatterPlot') {
                <app-widget-chart-scatterplot
                  #widgetComponent
                  [dashboard]="dashboard"
                  [widget]="widget"
                  [widgetDataSource]="widgetDataSource"
                  [widgetGroup]="widgetGroup"
                  [comparison]="comparison"
                  [project]="project"
                  (needRedraw)="redrawWidget($event)"
                  (syncItemColors)="onSyncItemColors($event)"
                  (resetItemColor)="onResetItemColor($event)"
                  (loadingStarted)="widgetLoading.emit($event)"
                  (loadingFinished)="onLoadingFinished($event)"
                  [isCustomSortMode]="isCustomSortMode"
                  [interactiveSmartSummaryEnabled]="interactiveSmartSummaryEnabled"
                  (isCustomSortModeChange)="onCustomSortModeChanged($event)"
                  (aiInsightPointSelection)="onAiInsightPointSelection($event)"
                />
              }
              @case ('documentCount') {
                <app-widget-chart-volume
                  #widgetComponent
                  [dashboard]="dashboard"
                  [widget]="widget"
                  [widgetDataSource]="widgetDataSource"
                  [widgetGroup]="widgetGroup"
                  [comparison]="comparison"
                  [project]="project"
                  (needRedraw)="redrawWidget($event)"
                  (syncItemColors)="onSyncItemColors($event)"
                  (resetItemColor)="onResetItemColor($event)"
                  (loadingStarted)="widgetLoading.emit($event)"
                  (loadingFinished)="onLoadingFinished($event)"
                  [isCustomSortMode]="isCustomSortMode"
                  [interactiveSmartSummaryEnabled]="interactiveSmartSummaryEnabled"
                  (isCustomSortModeChange)="onCustomSortModeChanged($event)"
                  (aiInsightPointSelection)="onAiInsightPointSelection($event)"
                />
              }
              @default {
                <app-widget-chart
                  #widgetComponent
                  [dashboard]="dashboard"
                  [widget]="widget"
                  [widgetDataSource]="widgetDataSource"
                  [widgetGroup]="widgetGroup"
                  [comparison]="comparison"
                  [project]="project"
                  (needRedraw)="redrawWidget($event)"
                  (syncItemColors)="onSyncItemColors($event)"
                  (resetItemColor)="onResetItemColor($event)"
                  (loadingStarted)="widgetLoading.emit($event)"
                  (loadingFinished)="onLoadingFinished($event)"
                  (reportResponseReady)="newspaperData = $event"
                  [isCustomSortMode]="isCustomSortMode"
                  [interactiveSmartSummaryEnabled]="interactiveSmartSummaryEnabled"
                  (isCustomSortModeChange)="onCustomSortModeChanged($event)"
                  (aiInsightPointSelection)="onAiInsightPointSelection($event)"
                />
              }
            }
          }
        }
        @case ('DashboardWidgetCrosstabComponent') {
          <app-widget-crosstab
            #widgetComponent
            [dashboard]="dashboard"
            [widget]="widget"
            [widgetDataSource]="widgetDataSource"
            [widgetGroup]="widgetGroup"
            [comparison]="comparison"
            [interactiveSmartSummaryEnabled]="interactiveSmartSummaryEnabled"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="widgetLoading.emit($event)"
            (loadingFinished)="onLoadingFinished($event)"
            [isCustomSortMode]="isCustomSortMode"
            (isCustomSortModeChange)="onCustomSortModeChanged($event)"
            (updateTitle)="onUpdateTitle()"
            (aiInsightPointSelection)="onAiInsightPointSelection($event)"
          />
        }
        @case ('DashboardWidgetFeatureScoringComponent') {
          <app-widget-topic-scoring
            #widgetComponent
            [dashboard]="dashboard"
            [widget]="widget"
            [widgetDataSource]="widgetDataSource"
            [widgetGroup]="widgetGroup"
            [comparison]="comparison"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="widgetLoading.emit($event)"
            (loadingFinished)="widgetLoaded.emit($event)"
          />
        }
        @case ('DashboardWidgetSentimentAccuracyComponent') {
          <app-widget-sentiment-accuracy
            #widgetComponent
            [dashboard]="dashboard"
            [widget]="widget"
            [widgetDataSource]="widgetDataSource"
            [widgetGroup]="widgetGroup"
            [comparison]="comparison"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="widgetLoading.emit($event)"
            (loadingFinished)="widgetLoaded.emit($event)"
          />
        }
      }

      <ng-template #chartDoclist>
        <app-widget-document-list
          #widgetComponent
          [dashboard]="dashboard"
          [widget]="widget"
          [widgetDataSource]="widgetDataSource"
          [widgetGroup]="widgetGroup"
          [comparison]="comparison"
          (needRedraw)="redrawWidget($event)"
          (loadingStarted)="widgetLoading.emit($event)"
          (loadingFinished)="widgetLoaded.emit($event)"
        >
        </app-widget-document-list>
      </ng-template>
    </div>

    <ng-template #aboutWidgetPopoverContent>
      <div class="about-widget-popover__content">
        <div class="about-widget-popover__name">
          {{ t('widgets.about-widget.' + aboutWidgetTypeKey + '.name') }}
        </div>
        <div class="about-widget-popover__description">
          {{ t('widgets.about-widget.' + aboutWidgetTypeKey + '.description') }}
        </div>
      </div>
    </ng-template>

    <ng-template #contentLimitTemplate let-popover>
      <div class="content-limit-popover">
        <div class="content-limit-popover__header">{{ t('widgets.content-limit') }}:</div>
        <div class="content-limit-popover__content">
          <xi-slider
            color="CX"
            [(value)]="widgetContentLimit"
            [max]="50"
            [min]="5"
            [increment]="5"
            (onSliderChange)="contentLimitChange$.next({ $event, popover })"
          ></xi-slider>
        </div>
      </div>
    </ng-template>

    <ng-template placement="bottom" #hiddenItemsPopContent let-popover>
      <div class="popunder-container">
        <div class="hidden-items-container">
          <mat-chip-listbox>
            @for (item of widget.payload.excludedValues; track item) {
              <mat-chip-option
                class="xi-default-button-normal-small"
                (removed)="removeHiddenItem(item, popover)"
              >
                <ng-container
                  *appMiddleEllipsize="item.displayName || item.name || item"
                ></ng-container>

                <mat-icon matChipRemove svgIcon="xi_cancel"></mat-icon>
              </mat-chip-option>
            }
          </mat-chip-listbox>
        </div>

        <div class="button-container">
          <xi-default-button
            [text]="t('widgets.clear-all')"
            (onClick)="removeAllHiddenItems(popover)"
          ></xi-default-button>
        </div>
      </div>
    </ng-template>

    <mat-menu class="menu-with-xi-icons" #widgetGroupMenu xPosition="before">
      <ng-template matMenuContent>
        <button
          mat-menu-item
          [disabled]="isWidgetDisabled"
          (click)="onOpenChangeWidgetGroupModal(false)"
          (mousedown)="$event.stopPropagation()"
        >
          <div>{{ t('widgets.change-widget-group') }}</div>
        </button>

        <div [matTooltip]="removeFromIPWGTooltip">
          <button
            mat-menu-item
            [disabled]="isWidgetDisabled || !canRemoveFromIPWG"
            (click)="onRemoveFromWidgetGroup()"
            (mousedown)="$event.stopPropagation()"
          >
            <div>{{ t('widgets.remove') }}</div>
          </button>
        </div>
      </ng-template>
    </mat-menu>

    <mat-menu class="menu-with-xi-icons" #widgetGroupParentMenu xPosition="before">
      <ng-template matMenuContent>
        <button
          mat-menu-item
          [disabled]="isWidgetDisabled"
          (click)="onOpenPromoteWidgetGroupModal()"
          (mousedown)="$event.stopPropagation()"
        >
          <div>{{ t('widgets.change-widget-group') }}</div>
        </button>
        <button
          mat-menu-item
          [disabled]="isWidgetDisabled"
          (click)="onDemoteFromWidgetGroup()"
          (mousedown)="$event.stopPropagation()"
        >
          <div>{{ t('widgets.demote-from-widget-group-parent') }}</div>
        </button>
        <button
          mat-menu-item
          [disabled]="isWidgetDisabled"
          (click)="onRemoveFromWidgetGroup()"
          (mousedown)="$event.stopPropagation()"
        >
          <div>{{ t('widgets.remove-from-widget-group') }}</div>
        </button>
      </ng-template>
    </mat-menu>

    <mat-menu class="menu-with-xi-icons" #comparisonMenu xPosition="before">
      <ng-template matMenuContent>
        <button
          mat-menu-item
          [disabled]="comparisonChangeDisabled() && isWidgetDisabled"
          (click)="openApplyComparison.emit({ widget, comparison })"
          (mousedown)="$event.stopPropagation()"
        >
          <div>{{ t('widgets.change-comparison') }}</div>
        </button>

        <div [matTooltip]="removeFromIPWGTooltip">
          <button
            mat-menu-item
            [disabled]="comparisonChangeDisabled() && isWidgetDisabled"
            (click)="onRemoveFromComparison()"
            (mousedown)="$event.stopPropagation()"
          >
            <div>{{ t('widgets.remove-comparison') }}</div>
          </button>
        </div>
      </ng-template>
    </mat-menu>

    <mat-menu class="menu-with-xi-icons" #widgetMenu xPosition="before">
      <ng-template matMenuContent>
        @if (canHideTitle) {
          <button mat-menu-item [disabled]="isWidgetDisabled" (click)="toggleTitleVisibility()">
            <mat-icon
              fontSet="kitchen-icons"
              [fontIcon]="
                widget.payload.hideTitle ? 'kxi-icon-visibility' : 'kxi-icon-visibility_off'
              "
            ></mat-icon>

            <div>
              {{ t('widgets.title-section-hide-display', { hide: widget.payload.hideTitle }) }}
            </div>
          </button>
        }

        @if (widgetActions.comments?.header === false) {
          <button
            mat-menu-item
            [matMenuTriggerFor]="commentsMenu"
            [matTooltip]="widgetActions.comments.tooltip"
            [disabled]="isWidgetDisabled || widgetActions.comments?.disabled"
          >
            <div
              class="widget__badge-menu-item"
              [matBadge]="widgetActions.comments.badge"
              matBadgeSize="small"
            >
              <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-comment"></mat-icon>
            </div>

            {{ t('widgets.comments.comments') }}
          </button>
        }

        @if (widgetActions.weight?.header === false) {
          <button
            mat-menu-item
            [disabled]="isWidgetDisabled || widgetActions.weight?.disabled"
            [matTooltip]="widgetActions.weight.tooltip"
            [matMenuTriggerFor]="weightMenu"
          >
            <div
              class="widget__badge-menu-item"
              [matBadge]="widget.payload.weightField ? '1' : ''"
              matBadgeSize="small"
            >
              <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-scale"></mat-icon>
            </div>

            {{ t('widgets.weight') }}
          </button>
        }

        @if (widgetActions.filter?.header === false) {
          <div>
            <button
              mat-menu-item
              [disabled]="isWidgetDisabled || widgetActions.filter?.disabled"
              (click)="filterWidget()"
              (mousedown)="$event.stopPropagation()"
              [matTooltip]="
                t('widgets.filtered-document-count', {
                  filteredCount: (currentFilteredDocumentCount | humanizeInt: 1 : 100000),
                  totalCount: (currentDocumentCount | humanizeInt: 1 : 100000),
                  percentage: filteredDocumentPercentage,
                })
              "
              matTooltipClass="filter-document-tooltip"
              matTooltipPosition="left"
            >
              <div
                class="widget__badge-menu-item"
                [matBadge]="hasFilters ? '1' : ''"
                matBadgeSize="small"
              >
                <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-filter"></mat-icon>
              </div>

              {{ t('widgets.filter') }}
            </button>
          </div>
        }

        @if (canBeParentOfFilterGroup) {
          <button
            mat-menu-item
            [disabled]="
              isWidgetDisabled ||
              isWidgetReadOnly ||
              !hasWidgetGroups ||
              !enabledToBeParentOfFilterGroup
            "
            (click)="onOpenPromoteWidgetGroupModal()"
            (mousedown)="$event.stopPropagation()"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-split_filled"></mat-icon>

            {{ t('widgets.set-as-widget-group-parent') }}
          </button>
        }

        @if (canAddToWidgetGroup()) {
          <button
            mat-menu-item
            [disabled]="isWidgetDisabled || isWidgetReadOnly || !hasWidgetGroups || !!widgetGroup"
            (click)="onOpenChangeWidgetGroupModal(true)"
            (mousedown)="$event.stopPropagation()"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-link"></mat-icon>

            {{ t('widgets.add-to-widget-group') }}
          </button>
        }

        @if (canAddToComparison()) {
          <div [matTooltip]="applyComparisonTooltip()">
            <button
              mat-menu-item
              [disabled]="isWidgetReadOnly || !canApplyComparison()"
              (click)="openApplyComparison.emit({ widget })"
              (mousedown)="$event.stopPropagation()"
            >
              <mat-icon
                fontSet="kitchen-icons"
                fontIcon="kxi-icon-search_suggestion_filled"
              ></mat-icon>

              {{ t('widgets.apply-comparison') }}
            </button>
          </div>
        }

        @if (widgetActions.hiddenItems?.header === false) {
          <button
            mat-menu-item
            #hiddenItemsPopover="ngbPopover"
            [disabled]="disabledWidgetHiddenItems"
            [ngbPopover]="hiddenItemsPopContent"
            triggers="manual"
            [popoverTitle]="t('widgets.hidden-items')"
            popoverClass="matmenu-popover"
            placement="left-top right-top"
            [autoClose]="'outside'"
            (click)="openHiddenItemsPopover(hiddenItemsPopover, $event)"
            (shown)="preventPropagation(hiddenItemsPopover)"
            (mousedown)="$event.stopPropagation()"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-visibility"></mat-icon>

            {{ t('widgets.hidden-items') }}
          </button>
        }

        @if (widgetActions?.sentimentFilter?.header === false) {
          <button
            mat-menu-item
            [disabled]="isWidgetDisabled || widgetActions.sentimentFilter?.disabled"
            triggers="manual"
            (click)="openWidgetSentimentFilter()"
            (mousedown)="$event.stopPropagation()"
          >
            <div
              class="widget__badge-menu-item"
              [matBadge]="widgetActions.sentimentFilter?.badge"
              matBadgeSize="small"
            >
              <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-sentiment_positive"></mat-icon>
            </div>

            {{ t('widgets.sentiment-filter') }}
          </button>
        }

        @if (widgetActions?.chartOptions?.header === false) {
          <button
            mat-menu-item
            [disabled]="isWidgetDisabled"
            (click)="onOpenWidgetChartOptionsModal()"
            (mousedown)="$event.stopPropagation()"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-chart"></mat-icon>

            {{ t('widgets.chart-options') }}
          </button>
        }

        @if (widgetActions?.analyticItem?.header === false && canChangeAnalyticItem()) {
          <div
            [matTooltip]="analyticItemChangeDisabled() ? widgetAnalyticTypeTooltip() : undefined"
          >
            <button
              mat-menu-item
              [disabled]="isWidgetDisabled || analyticItemChangeDisabled()"
              (click)="openAnalyticTypeDialog()"
              (mousedown)="$event.stopPropagation()"
            >
              <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-reporting"></mat-icon>

              {{ t('widgets.analytic-item') }}
            </button>
          </div>
        }

        @if (widgetActions?.contentLimit?.header === false) {
          <button
            mat-menu-item
            #contentLimitPopover="ngbPopover"
            [disabled]="disabledContentLimit()"
            [ngbPopover]="contentLimitTemplate"
            popoverClass="content-limit-popover"
            triggers="manual"
            placement="left right"
            [autoClose]="'outside'"
            [container]="'body'"
            (click)="openContentLimitPopover(contentLimitPopover, $event)"
            (shown)="preventPropagation(contentLimitPopover)"
            class="content-limit-menu"
            (mousedown)="$event.stopPropagation()"
          >
            <mat-icon>
              <div
                class="content-limit-menu__label"
                [class.content-limit-menu__label--disabled]="disabledContentLimit()"
              >
                {{ contentLimitLabel() }}
              </div>
            </mat-icon>

            {{ t('widgets.content-limit') }}
          </button>
        }
        @if (widgetActions?.aiInsights?.header === false) {
          <div
            [matTooltip]="
              isShowAsDataTable
                ? t('widgets.ai-insights.disabled-data-table')
                : widgetActions?.aiInsights?.tooltip
            "
          >
            <button
              mat-menu-item
              [disabled]="
                isWidgetDisabled || isShowAsDataTable || widgetActions.aiInsights.disabled
              "
              (click)="onAiInsightsOpenClicked()"
              (mousedown)="$event.stopPropagation()"
            >
              <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-lightbulb"></mat-icon>

              {{ t('widgets.ai-insights.title') }}
            </button>
          </div>
        }
        @if (!isShowAsDocumentList && canShowDocumentList) {
          <button
            mat-menu-item
            [disabled]="isWidgetDisabled"
            (click)="showAsDocumentList()"
            (mousedown)="$event.stopPropagation()"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-list_view"></mat-icon>

            {{ t('widgets.show-as-document-list') }}
          </button>
        }

        @if (!isShowAsDataTable && canShowDataTable) {
          <button
            mat-menu-item
            [disabled]="isWidgetDisabled"
            (click)="showAsDataTable()"
            (mousedown)="$event.stopPropagation()"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-view_table"></mat-icon>

            {{ t('widgets.show-as-data-table') }}
          </button>
        }
        @if (
          (canShowDocumentList && isShowAsDocumentList) || (canShowDataTable && isShowAsDataTable)
        ) {
          <button
            mat-menu-item
            [disabled]="isWidgetDisabled"
            (click)="showAsGraph()"
            (mousedown)="$event.stopPropagation()"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-chart_1"></mat-icon>

            {{ t('widgets.show-as-graph') }}
          </button>
        }
        @if (canCreateCollection && !dashboard.locked) {
          <button
            mat-menu-item
            [disabled]="isWidgetDisabled || !currentFilteredDocumentCount"
            [matMenuTriggerFor]="collectionsMenuTrigger"
            (mousedown)="$event.stopPropagation()"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-collections"></mat-icon>

            {{ t('widgets.collections') }}
          </button>
        }

        <mat-menu #collectionsMenuTrigger class="menu-with-xi-icons" xPosition="after">
          <button
            mat-menu-item
            (click)="openSaveDocumentsToCollection('NEW', 'WIDGET')"
            (mousedown)="$event.stopPropagation()"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-document"></mat-icon>

            {{ t('widgets.new-collection') }}
          </button>

          <button
            mat-menu-item
            (click)="openSaveDocumentsToCollection('EXISTING', 'WIDGET')"
            (mousedown)="$event.stopPropagation()"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-add_circle"></mat-icon>

            {{ t('widgets.add-to-collection') }}
          </button>

          @if (hasDriverAnalysisFeature) {
            <button
              mat-menu-item
              [matTooltip]="driverAnalysisTooltip"
              matTooltipPosition="left"
              [disabled]="!!driverAnalysisTooltip && !canCreateKda"
              (click)="onCreateDriverAnalysisClicked()"
            >
              <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-survey_authoring"></mat-icon>

              {{ t('widgets.run-key-driver-analysis') }}
            </button>
          }
        </mat-menu>
        @if (isNote) {
          <button mat-menu-item (click)="editNote = 'edit'">
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-edit"></mat-icon>

            {{ t('widgets.edit') }}
          </button>
        }
        @if (canDownload) {
          <button
            mat-menu-item
            [disabled]="isWidgetDisabled"
            [matMenuTriggerFor]="downloadMenuTrigger"
            (mousedown)="$event.stopPropagation()"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-download"></mat-icon>

            {{ t('widgets.download') }}
          </button>
        }

        <mat-menu #downloadMenuTrigger class="menu-with-xi-icons" xPosition="after">
          @if (canDownloadExcel) {
            <button
              mat-menu-item
              [disabled]="isWidgetDisabled"
              (click)="downloadAsExcel()"
              (mousedown)="$event.stopPropagation()"
            >
              <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-download"></mat-icon>

              {{ t('widgets.download-as-excel') }}
            </button>
          }
          @if (canDownloadCSV) {
            <button
              mat-menu-item
              [disabled]="isWidgetDisabled"
              (click)="downloadAsCsv()"
              (mousedown)="$event.stopPropagation()"
            >
              <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-download"></mat-icon>

              {{ t('widgets.download-as-csv') }}
            </button>
          }
          @if (canDownloadPPTX) {
            <button
              mat-menu-item
              [disabled]="isWidgetDisabled"
              (click)="downloadAsPptx()"
              (mousedown)="$event.stopPropagation()"
            >
              <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-download"></mat-icon>

              {{ t('widgets.download-as-powerpoint') }}
            </button>
          }

          @if (canDownloadImage) {
            <button
              mat-menu-item
              [disabled]="isWidgetDisabled"
              (click)="downloadAsImage()"
              (mousedown)="$event.stopPropagation()"
            >
              <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-download"></mat-icon>

              {{ t('widgets.download-as-image') }}
            </button>
          }
          @if (canDownloadTable) {
            <button
              mat-menu-item
              [disabled]="isWidgetDisabled"
              (click)="downloadAsTable()"
              (mousedown)="$event.stopPropagation()"
            >
              <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-download"></mat-icon>

              {{ t('widgets.download-as-table') }}
            </button>
          }
        </mat-menu>

        @if (canBeCloned) {
          <div [matTooltip]="cloneWidgetTooltip">
            <button
              mat-menu-item
              (click)="cloneClick()"
              [disabled]="isWidgetDisabled || !canAddWidget"
              (mousedown)="$event.stopPropagation()"
            >
              <mat-icon
                fontSet="kitchen-icons"
                fontIcon="kxi-icon-copy"
                [color]="isWidgetDisabled || !canAddWidget ? 'disabled' : 'CX'"
              ></mat-icon>

              {{ t('widgets.clone-widget') }}
            </button>
          </div>

          <button
            mat-menu-item
            [matMenuTriggerFor]="pagesSubMenu"
            [matMenuTriggerData]="{ callback: cloneClick.bind(this) }"
            [disabled]="isWidgetDisabled || dashboard.payload.pages.length === 1"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-copy"></mat-icon>

            {{ t('widgets.clone-to-another-page') }}
          </button>

          <button
            mat-menu-item
            [matMenuTriggerFor]="pagesSubMenu"
            [matMenuTriggerData]="{ callback: moveClick.bind(this) }"
            [disabled]="isWidgetDisabled || dashboard.payload.pages.length === 1"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-exchange"></mat-icon>

            {{ t('widgets.move-to-another-page') }}
          </button>
        }

        @if (isNote) {
          <button
            mat-menu-item
            [ngbPopover]="aboutWidgetPopoverContent"
            triggers="mouseenter:mouseleave"
            placement="left-top left right"
            [container]="'body'"
            popoverClass="about-widget-popover"
            (click)="$event.stopPropagation()"
            (mousedown)="$event.stopPropagation()"
          >
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-info"></mat-icon>
            <div>{{ t('widgets.about-widget.title') }}</div>
          </button>
        }

        @if (canBeDeleted) {
          <button mat-menu-item (click)="deleteClick()" (mousedown)="$event.stopPropagation()">
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-trash"></mat-icon>

            {{ t('widgets.delete-widget') }}
          </button>
        }
      </ng-template>
    </mat-menu>

    <mat-menu #weightMenu>
      <ng-template matMenuContent>
        <button
          mat-menu-item
          matSuffix
          (mousedown)="$event.stopPropagation()"
          (click)="setWeightField()"
          class="widget__weight-menu-item"
        >
          <span
            class="widget__weight-menu-item__label"
            [class.bold-medium]="!widget.payload.weightField"
            >{{ t('widgets.no-weighting') }}</span
          >

          @if (!widget.payload.weightField) {
            <mat-icon
              fontSet="kitchen-icons"
              fontIcon="kxi-icon-circle_check_filled"
              class="widget__weight-menu-item__icon"
            ></mat-icon>
          }
        </button>

        @for (field of weightFields; track field) {
          <div class="widget__weight-menu-item__divider" role="separator"></div>

          <button
            mat-menu-item
            matSuffix
            (mousedown)="$event.stopPropagation()"
            (click)="setWeightField(field)"
            class="widget__weight-menu-item"
          >
            <span
              class="widget__weight-menu-item__label"
              [class.bold-medium]="widget.payload.weightField === field.fieldName"
              >{{ field.displayName }}</span
            >
            @if (widget.payload.weightField === field.fieldName) {
              <mat-icon
                fontSet="kitchen-icons"
                fontIcon="kxi-icon-circle_check_filled"
                class="widget__weight-menu-item__icon"
              ></mat-icon>
            }
          </button>
        }
      </ng-template>
    </mat-menu>

    <mat-menu #pagesSubMenu class="widget__pages-submenu">
      <ng-template matMenuContent let-callback="callback">
        @for (page of dashboard.payload.pages; track page.id) {
          <div
            [matTooltip]="
              dashboardViewComponent?.isPageFull(page) ? t('widgets.page-is-full') : null
            "
          >
            <button
              mat-menu-item
              [disabled]="
                page.id === widget.payload.page || dashboardViewComponent?.isPageFull(page)
              "
              (click)="callback(page.id)"
              (mousedown)="$event.stopPropagation()"
            >
              {{ page.title }}
            </button>
          </div>
        }
      </ng-template>
    </mat-menu>

    <mat-menu #commentsMenu class="menu-with-xi-icons" xPosition="before">
      <ng-template matMenuContent>
        @if (widget?.payload?.commentsHidden) {
          <button mat-menu-item (click)="showComments()">
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-visibility"></mat-icon>

            {{ t('widgets.comments.list.show-hidden-comments') }}
          </button>
        } @else {
          <ng-container *ngTemplateOutlet="hideCommentTemplate" />
        }

        <ng-template #hideCommentTemplate>
          <button mat-menu-item (click)="hideComments()">
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-visibility_off"></mat-icon>

            {{ t('widgets.comments.hide') }}
          </button>
        </ng-template>

        <button mat-menu-item (click)="onCommentListOpenClicked()">
          <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-list_view"></mat-icon>

          {{ t('widgets.comments.open-list') }}
        </button>
      </ng-template>
    </mat-menu>
  </div>

  @if (showCommentList) {
    <div #commentListContainer class="widget__expansion-panel-container">
      <app-widget-expansion-panel
        [title]="t('widgets.comments.list.title')"
        (onClose)="onCommentListCloseClicked()"
      >
        <app-widget-comment-list
          [options]="commentListModalOptions"
          (smartSummaryOpen)="openSmartySummaryFromComment($event)"
          (setAnnotationSelected)="setAnnotationSelected($event)"
          (deleteComment)="onCommentDeleted($event)"
          (openComment)="onOpenComment($event)"
        ></app-widget-comment-list>
      </app-widget-expansion-panel>
    </div>
  }

  @if (showAiInsights) {
    <div #aiInsightsContainer class="widget__expansion-panel-container">
      <app-widget-expansion-panel
        [title]="t('widgets.ai-insights.title')"
        (onClose)="onAiInsightsCloseClicked()"
      >
        <app-widget-ai-insights
          [options]="aiInsightsOptions"
          [selectedPoints]="aiInsightsSelectedPoints"
          (choosePoints)="onChooseAiInsightPoints($event)"
          (autoChoosePoints)="onAutoChooseAiInsightPoints($event)"
          (resetPoints)="onResetAiInsightPoints()"
          (insightCreated)="onAiInsightCreated($event)"
        ></app-widget-ai-insights>
      </app-widget-expansion-panel>
    </div>
  }

  @if (widget.payload.newspaper?.show) {
    <div
      class="widget__newspaper-content"
      [ngClass]="isNewspaperShowing ? 'widget__newspaper-content--width-' + widget.cols : ''"
    >
      <app-newspaper-widglet
        [widget]="widget"
        [dataSource]="widgetDataSource"
        [widgetGroup]="widgetGroup"
        [comparison]="comparison"
        [weightField]="widget.payload.weightField"
        [filterSet]="widget.payload.filters"
        [documentsQuery]="query"
        [reportData]="newspaperData"
      ></app-newspaper-widglet>
    </div>
  }

  @if (showWidgetChartOptionsModal) {
    <app-lex-xi-modal
      [isVisible]="showWidgetChartOptionsModal"
      [maxWidth]="chartOptionsMaxWidth"
      (close)="onWidgetChartOptionsModalClosed(null)"
    >
      <ng-template appXIModalContent>
        @if (
          showWidgetChartOptionsModal &&
          !isPredictive &&
          widget.payload.type !== 'bigNumber' &&
          widget.payload.type !== 'donut' &&
          widget.payload.type !== 'grid' &&
          widget.payload.type !== 'gauge'
        ) {
          <app-chart-options-dialog
            [data]="chartOptionsData"
            (modalClosed)="onWidgetChartOptionsModalClosed($event)"
          />
        }

        @if (widget.payload.type === 'bigNumber' && !isPredictive) {
          <app-big-number-chart-options-dialog
            [data]="chartOptionsData"
            (modalClosed)="onWidgetChartOptionsModalClosed($event)"
          />
        }

        @switch (widget.payload.type) {
          @case ('donut') {
            <app-donut-chart-options-dialog
              [data]="chartOptionsData"
              (modalClosed)="onWidgetChartOptionsModalClosed($event)"
            ></app-donut-chart-options-dialog>
          }
          @case ('gauge') {
            <app-gauge-chart-options-dialog
              [data]="chartOptionsData"
              (modalClosed)="onWidgetChartOptionsModalClosed($event)"
            ></app-gauge-chart-options-dialog>
          }
          @case ('grid') {
            <app-grid-chart-options-dialog
              [data]="chartOptionsData"
              [isReadOnly]="isWidgetReadOnly"
              (modalClosed)="onWidgetChartOptionsModalClosed($event)"
            ></app-grid-chart-options-dialog>
          }
        }

        @if (showWidgetChartOptionsModal && isPredictive) {
          <app-predictive-chart-options-dialog
            [data]="chartOptionsData"
            (modalClosed)="onWidgetChartOptionsModalClosed($event)"
          ></app-predictive-chart-options-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }

  @if (showWidgetWidgetGroupModal) {
    <app-lex-xi-modal
      [isVisible]="showWidgetWidgetGroupModal"
      maxWidth="600px"
      (close)="onWidgetWidgetGroupModalClosed(null)"
    >
      <ng-template appXIModalContent>
        @if (showWidgetWidgetGroupModal) {
          <app-change-widget-group-dialog
            [widget]="widget"
            [isAdding]="addingToWidgetGroup"
            [forParents]="adjustingFilterGroupParent"
            [dashboard]="dashboard"
            (modalClosed)="onWidgetWidgetGroupModalClosed($event)"
          ></app-change-widget-group-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
  @if (showAddFilterToWidgetGroupModal) {
    <app-lex-xi-modal
      [isVisible]="showAddFilterToWidgetGroupModal"
      maxWidth="720px"
      (close)="onCloseAddFilterToWidgetGroup()"
    >
      <ng-template appXIModalContent>
        @if (showAddFilterToWidgetGroupModal) {
          <app-add-to-widget-group-dialog
            [widgetGroupsInput]="addFilterAvailableWidgetGroups"
            [widget]="widget"
            [disableType]="true"
            (modalClosed)="onCloseAddFilterToWidgetGroup($event)"
          ></app-add-to-widget-group-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }

  @if (showDocListSettingsModal) {
    <app-lex-xi-modal
      [isVisible]="showDocListSettingsModal"
      [canBackdropClose]="false"
      maxWidth="720px"
      (close)="onCloseDocListSettingsModal(null)"
    >
      <ng-template appXIModalContent
        ><app-document-list-settings-dialog
          [options]="docListSettingsOptions"
          [isReadOnly]="isWidgetReadOnly"
          (modalClosed)="onCloseDocListSettingsModal($event)"
        ></app-document-list-settings-dialog>
      </ng-template>
    </app-lex-xi-modal>
  }

  @if (showAnalyticItemModal) {
    <app-lex-xi-modal
      [isVisible]="showAnalyticItemModal"
      [canBackdropClose]="false"
      [maxWidth]="analyticItemModalWidth()"
      (close)="onCloseAnalyticItemModal(null)"
    >
      <ng-template appXIModalContent>
        <app-widget-analytic-item-dialog
          [options]="analyticItemModalOptions"
          (isSectionSelectorAvailableChange)="setAnalyticItemModalMaxwidth($event)"
          (modalClosed)="onCloseAnalyticItemModal($event)"
        >
        </app-widget-analytic-item-dialog>
      </ng-template>
    </app-lex-xi-modal>
  }

  @if (showCrosstabAnalyticItemsModal) {
    <app-lex-xi-modal
      [isVisible]="showCrosstabAnalyticItemsModal"
      [canBackdropClose]="false"
      maxWidth="100vw"
      (close)="onCloseCrosstabAnalyticItemsModal(null)"
    >
      <ng-template appXIModalContent>
        <app-crosstab-analytic-items-dialog
          [options]="crosstabAnalyticItemModalOptions"
          (modalClosed)="onCloseCrosstabAnalyticItemsModal($event)"
        >
        </app-crosstab-analytic-items-dialog>
      </ng-template>
    </app-lex-xi-modal>
  }

  @if (showGridAnalyticItemSelectorDialog) {
    <app-lex-xi-modal
      [isVisible]="showGridAnalyticItemSelectorDialog"
      [canBackdropClose]="false"
      maxWidth="950px"
      (close)="onCloseGridAnalyticItemSelectorDialog(null)"
    >
      <ng-template appXIModalContent>
        @if (showGridAnalyticItemSelectorDialog) {
          <app-grid-analytic-item-selector-dialog
            [options]="gridAnalyticItemSelectorDialogOptions"
            (close)="onCloseGridAnalyticItemSelectorDialog($event)"
          >
          </app-grid-analytic-item-selector-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }

  @if (showJourneyAnalyticItemSelectorDialog) {
    <app-lex-xi-modal
      [isVisible]="showJourneyAnalyticItemSelectorDialog"
      [canBackdropClose]="false"
      maxWidth="1200px"
      (close)="onCloseJourneyAnalyticItemSelectorDialog(null)"
    >
      <ng-template appXIModalContent>
        @if (showJourneyAnalyticItemSelectorDialog) {
          <app-journey-analytic-item-selector-dialog
            [options]="journeyAnalyticItemSelectorDialogOptions"
            (close)="onCloseJourneyAnalyticItemSelectorDialog($event)"
          >
          </app-journey-analytic-item-selector-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }

  @if (showEditCommentModal) {
    <app-lex-xi-modal
      [isVisible]="showEditCommentModal"
      [canBackdropClose]="false"
      maxWidth="800px"
      (close)="onCommentDialogClosed()"
    >
      <ng-template appXIModalContent>
        @if (showEditCommentModal) {
          <app-comment-dialog
            [options]="commentModalOptions"
            (modalClosed)="onCommentDialogClosed($event)"
            (openSmartSummary)="onOpenSmartSummaryFromComment($event)"
          ></app-comment-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }

  @if (showInsightFeedModal) {
    <app-lex-xi-modal
      [isVisible]="showInsightFeedModal"
      [canBackdropClose]="false"
      maxWidth="720px"
      (close)="onCreateInsightFeedModalClosed(null)"
    >
      <ng-template appXIModalContent>
        <app-create-insight-feed-dialog
          [options]="insightFeedModalOptions"
          (modalClosed)="onCreateInsightFeedModalClosed($event)"
        ></app-create-insight-feed-dialog>
      </ng-template>
    </app-lex-xi-modal>
  }

  @if (showSaveDocumentsToCollectionModal) {
    <app-lex-xi-modal
      [isVisible]="showSaveDocumentsToCollectionModal"
      [canBackdropClose]="false"
      maxWidth="60vw"
      (close)="onSaveDocumentsToCollectionClosed(null)"
    >
      <ng-template appXIModalContent>
        <app-save-to-collection-dialog
          [options]="saveDocumentsToCollectionModalOptions"
          (modalClosed)="onSaveDocumentsToCollectionClosed($event)"
        ></app-save-to-collection-dialog>
      </ng-template>
    </app-lex-xi-modal>
  }

  @if (isImageExporting) {
    <div class="image-export-progress-bar">
      <mat-progress-bar mode="determinate" [value]="50"></mat-progress-bar>
    </div>
  }
</ng-container>
